module.exports = __webpack_public_path__ + "static/media/logonav3.84dc74b7.png";